/**
 * Help text for payroll calculation fields (tooltips / hints).
 */
export const DAILY_RATE_FORMULA_HINT =
  'Daily rate = (Basic monthly ÷ 173) × 8. ' +
  '173 is the monthly hours divisor and 8 is the statutory full-day hours.';
